export const PICK = "pick";
export const STAGE = "stage";
export const OUTBOUND = "outbound";
export const INDUCT = "induct";
export const SORT = "sort";
export const STOW_WIP = "stowWip";
export const STOW_WIP_COMPLIANCE = "stowWipCompliance";
export const SF_STOW_WIP_THRESHOLD = 30;
export const DEFAULT_CYCLE = "CYCLE_1";
export const SWA_REVERSE_CYCLE_ID = "REVERSE";
export const SWA_REVERSE_CYCLE_NAME = "SWA";
export const OCR_CLASSIFICATION_LOCALE = {
  HIGH: "ocr.classification.high",
  MEDIUM: "ocr.classification.medium",
};



// WEBPACK FOOTER //
// ./src/components/overview/utils/Constants.js